import { REACT_APP_API_BASE_URL } from "../../constants/config";

export async function getZegoToken(uid: string): Promise<string> {
  if (!uid) {
    throw new Error(
      "Channel name and UID are required to generate Agora token",
    );
  }

  const url = `${REACT_APP_API_BASE_URL}/zegocloud/generate-token/${uid}`;

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    console.log("response and token", response);

    console.log(
      "[getAgoraToken] Response Status:",
      response.status,
      response.statusText,
    );

    if (!response.ok) {
      throw new Error(`Failed to fetch token (Status: ${response.status})`);
    }

    const result = await response.json();
    console.log("[getAgoraToken] API Response:", result);

    const token = result?.data;
    if (!token) {
      throw new Error("Token not found in API response");
    }

    console.log("[getAgoraToken] Token retrieved successfully");
    return token;
  } catch (err: any) {
    console.error("[getAgoraToken] ERROR:", err);
    throw new Error(`Error in token generation: ${err.message || err}`);
  }
}
